import React from 'react';
import {FORGET_PASSWORD, LOGIN, REGISTER, RESET_PASSWORD, VERIFY} from "../constants/urls";

const Login = React.lazy(() => import('../containers/auth/login'));
const Register = React.lazy(() => import('../containers/auth/register'));
const Verify = React.lazy(() => import('../containers/auth/verify'));
const Forget = React.lazy(() => import('../containers/auth/forget'));
const Reset = React.lazy(() => import('../containers/auth/reset'));

const routes = [
    {
        path:LOGIN,
        component: Login,
        layout:'centralize',
        visibility: 'guest' //all , guest , trust
    },
    {
        path:REGISTER,
        component: Register,
        layout:'centralize',
        visibility: 'all' //all , guest , trust
    },
    {
        path:VERIFY,
        component: Verify,
        layout:'centralize',
        visibility: 'guest' //all , guest , trust
    },
    {
        path:FORGET_PASSWORD,
        component: Forget,
        layout:'centralize',
        visibility: 'guest' //all , guest , trust
    },
    {
        path:RESET_PASSWORD,
        component: Reset,
        layout:'centralize',
        visibility: 'guest' //all , guest , trust
    }

];
export default routes;